module.exports = __webpack_public_path__ + "img/shield-search.bb906209.svg";